<div class="wrapper-list-stores">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Products" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="fixed bottom w-[86.8%] md:w-[80%] z-50 bottom-0 pointer-events-none"
    [class]="isTileView ? '' : ''"
  >
    <div
      class="md:w-1/2 sm:w-[80%] w-full mt-10 bg-indigo-500 text-white p-2 shadow-md mx-auto transition ease-in-out duration-400 rounded flex place-content-between pointer-events-auto"
      [class]="
        isArrangementModified
          ? '-translate-y-1/2 opacity-100'
          : 'translate-y-full opacity-0'
      "
    >
      <span class="align-self-center ml-2">{{
        isArrangementModified
          ? ("Product arrangement has been modified! Save now?" | translate)
          : ("Not Modified" | translate)
      }}</span>
      <button
        class="bg-white text-indigo-600 px-4 py-2 rounded hover:!bg-indigo-100 transition duration-300 ease-in-out"
        [class]="
          isSavingArrangement
            ? 'pointer-events-none !bg-white/[.6]'
            : 'pointer-events-auto'
        "
        (click)="saveProductArrangement($event)"
      >
        {{ "Save" | translate }}
      </button>
    </div>
  </div>
  <!-- <div class="form-group">
            <div  class="d-inline-block w-100">
                <button routerLink='/dashboard/product-manager-form' class="btn btn-click" >Create Customer Product</button>
            </div>
        </div> -->
  <div class="checkout-toolbar mb-4">
    <div class="filter-options">
      <!-- Country Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="filteredCountry"
          id="dropdownCountry"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-globe mr-1"></i>
          <span>{{ getCountryName(filteredCountry) | translate }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownCountry" class="custom-dropdown shadow-md" style="min-width: 220px; max-height: 320px; overflow-y: auto;">
          <button
            ngbDropdownItem
            *ngFor="let c of country"
            (click)="changeCountry(c.country_code)"
            class="py-2"
          >
            <div class="d-flex align-items-center">
              <img
                *ngIf="c.country_code"
                [src]="getFlagImageURL(c.country_code)"
                class="mr-2 flex-shrink-0"
                style="width: 20px; height: 14px; object-fit: cover; border-radius: 2px;"
              />
              <i *ngIf="!c.country_code" class="fi fi-rr-globe mr-2 text-muted" style="font-size: 14px;"></i>
              <span class="text-truncate">{{ c.country_name | translate }}</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Language Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="language_code"
          id="dropdownLanguage"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-world mr-1"></i>
          <span>{{ language_name }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownLanguage" class="custom-dropdown shadow-md" style="min-width: 180px;">
          <button
            ngbDropdownItem
            *ngFor="let l of language"
            (click)="changeLanguage(l.language_code, l.language_name)"
            class="py-2"
          >
            <span>{{ l.language_name }}</span>
          </button>
        </div>
      </div>

      <!-- Subscription Filter Dropdown -->
      <div ngbDropdown class="d-inline-block" *ngIf="subscriptionProduct">
        <button
          class="btn btn-filter"
          id="dropdownSubscription"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-box mr-1"></i>
          <span>{{ getSubscription(filteredSubscription) | translate }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownSubscription" class="custom-dropdown shadow-md" style="min-width: 180px;">
          <button
            ngbDropdownItem
            *ngFor="let sub of subscription_status"
            (click)="changeSubscription(sub)"
            class="py-2"
          >
            <span>{{ sub | translate }}</span>
          </button>
        </div>
      </div>

      <!-- View Mode Switcher (List vs Grid) -->
      <div class="view-mode-toggle">
        <button
          type="button"
          class="btn-view-option"
          [class.active]="isListView"
          (click)="changeListingView('list')"
          title="{{ 'List View' | translate }}"
        >
          <i class="fi fi-rr-menu-burger"></i>
        </button>
        <button
          type="button"
          class="btn-view-option"
          [class.active]="isTileView"
          (click)="changeListingView('tile')"
          title="{{ 'Grid View' | translate }}"
        >
          <i class="fi fi-rr-grid"></i>
        </button>
      </div>
    </div>

    <!-- Search Input Box -->
    <div class="search-box">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filteredString"
        (input)="updateFilter($event)"
        placeholder="{{ 'Filter by product name or sku' | translate }}..."
      />
      <i class="fi fi-rr-search search-icon"></i>
      <i class="fas fa-times clear-icon" *ngIf="filteredString" (click)="clearProductSearch()"></i>
    </div>
  </div>

  <div class="section-main">
    <!-- Product Listing View: Tiles -->
    <div
      class="product-list"
      [class]="{
        'listing-mode-tile': isListView,
        'listing-mode-list': isTileView
      }"
    >
      <div *ngIf="loading">
        <div class="loading-spinner col-12 mt-5">
          <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
        </div>
      </div>
      <div *ngIf="!loading" cdkDropListGroup>
        <div
          class="flex flex-wrap ease-in-out duration-300 py-3"
          [class]="isTileView ? 'divide-y divide-slate-200/50 ' : ''"
        >
          <div
            *ngFor="let item of getDisplayedProducts()"
            cdkDropList
            [cdkDropListEnterPredicate]="dropListEnterPredicate"
            class="select-none product-item-tile duration-1000 transition ease-in-out"
            [class]="
              isListView
                ? 'w-full group -mb-3'
                : 'xl:w-[20%] lg:w-[25%] md:w-[33.3%] w-[50%]'
            "
          >
            <div
              cdkDrag
              (cdkDragMoved)="dragMoved($event)"
              (cdkDragDropped)="dragDropped($event)"
              [cdkDragData]="item"
              class="drag-box"
            >
              <div
                class="flex relative transition bg-white dark:bg-gray-800 duration-300 ease-in-out shadow-sm hover:!shadow-lg group"
                [class]="
                  isListView
                    ? 'flex-row p-3 border !border-gray-200 hover:!bg-slate-50 dark:hover:!bg-slate-800 group-first:!rounded-t-md group-last:!rounded-b-md'
                    : 'flex-column border !border-transparent rounded hover:!border-indigo-200'
                "
              >
                <div
                  *ngIf="isListView"
                  class="text-start truncate align-items-center flex mr-4"
                >
                  <div
                    class="text-sm font-medium text-start flex items-center w-6 h-6 justify-center cursor-grab"
                  >
                    <svg
                      width="16"
                      height="6"
                      viewBox="0 0 16 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 0H1C0.45 0 0 0.45 0 1C0 1.55 0.45 2 1 2H15C15.55 2 16 1.55 16 1C16 0.45 15.55 0 15 0ZM1 6H15C15.55 6 16 5.55 16 5C16 4.45 15.55 4 15 4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6Z"
                        fill="#747E8B"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  class="aspect-square content-center p-1"
                  [class]="isListView ? 'w-14 h-14' : 'h-auto w-full '"
                >
                  <div class="relative pt-[100%]">
                    <div
                      class="absolute z-[1]"
                      [class]="isListView ? '-left-2 -top-2' : 'right-1 top-1 '"
                    >
                      <div
                        #tooltip="matTooltip"
                        [matTooltip]="getCountryName(item?.country_code)"
                        matTooltipPosition="above"
                        matTooltipHideDelay="100"
                        class="rounded-full border-2 border-white relative shadow overflow-hidden bg-white"
                        [class]="isListView ? '' : 'right-1 top-1'"
                      >
                        <img
                          [src]="getFlagImageURL(item?.country_code)"
                          class="object-cover"
                          [class]="isListView ? 'w-4 h-4' : 'w-6 h-6'"
                        />
                      </div>
                    </div>
                    <img
                      [src]="item.image"
                      class="absolute inset-0 object-cover rounded h-full w-full'"
                    />
                    <!-- [class]="isListView ? 'h-auto w-auto' : 'h-full w-full'" -->
                  </div>
                </div>
                <div
                  class="flex justify-between w-full"
                  [class]="isListView ? 'px-2 py-2 !pt-0' : 'px-3 py-3 !pt-2'"
                >
                  <div class="text-start truncate">
                    <div
                      class="capitalize text-sm font-medium text-start truncate"
                    >
                      {{ item.product_name?.toLowerCase() }}
                    </div>
                    <div class="text-xs">
                      {{
                        item.retail_price_per_item
                          | currency
                            : item.currency
                            : item.currency_symbol + " "
                      }}
                    </div>
                    <!-- Info message for mapped products -->
                    <div
                      *ngIf="item.is_product_mapped"
                      class="text-xs text-amber-600 mt-1 flex items-center gap-1 min-w-0"
                    >
                      <i class="fi fi-rr-info flex-shrink-0"></i>
                      <span
                        [class]="
                          isTileView
                            ? 'truncate'
                            : 'truncate sm:whitespace-normal sm:overflow-visible'
                        "
                        #tooltip="matTooltip"
                        [matTooltip]="
                          'This product is changed / wrongly mapped.'
                            | translate
                        "
                        matTooltipPosition="above"
                        matTooltipHideDelay="100"
                      >{{
                        "This product is changed / wrongly mapped."
                          | translate
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="actions self-center flex gap-1"
                    [class]="
                      isListView ? 'lg:w-1/5  lg:place-content-between' : ''
                    "
                  >
                    <div class="display-toggle flex">
                      <!-- Show "ACTIVE" text when item.is_pwp = 1 -->
                      <div 
                        *ngIf="item.is_pwp === '1'" 
                        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800"
                      >
                        {{ "ACTIVE" | translate }}
                      </div>
                      
                      <!-- Show toggle button when item.is_pwp !== 1 -->
                      <label
                        *ngIf="item.is_pwp !== '1'"
                        class="inline-flex relative items-center mb-0"
                        [class]="
                          isUpdatingDisplay(item.p_id)
                            ? 'opacity-50 cursor-not-allowed'
                            : 'cursor-pointer'
                        "
                      >
                        <input
                          [disabled]="isUpdatingDisplay(item.p_id)"
                          type="checkbox"
                          class="sr-only peer"
                          (change)="
                            updateDisplayStatus(
                              item.p_id,
                              !isHidden(item.display_status),
                              $event
                            )
                          "
                          [ngModel]="isHidden(item.display_status)"
                        />
                        <div
                          #tooltip="matTooltip"
                          matTooltip="{{
                            'Toggle this button to display or hide this product in your Store'
                              | translate
                          }}"
                          matTooltipPosition="above"
                          matTooltipHideDelay="100"
                          class="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-slate-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500 after:mt-1"
                        ></div>
                      </label>
                    </div>

                    <div class="action-group whitespace-nowrap">
                      <button
                        class="inline-flex rounded-md ml-2 text-xs bg-white justify-center items-center h-8 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-gray-300 hover:!border-red-200 !border text-red-600 hover:text-red-800 hover:!bg-red-50/[0.5] group hover:no-underline"
                        [class]="isListView ? 'px-2' : 'w-8'"
                        #tooltip="matTooltip"
                        matTooltip="{{
                          'Reset all changes back to default' | translate
                        }}"
                        matTooltipPosition="above"
                        matTooltipHideDelay="100"
                        (click)="resetProductCustom(item.p_id)"
                        *ngIf="item.is_product_custom"
                      >
                        <!-- <i class="fi fi-rs-menu-dots-vertical"></i> -->
                        <i class="fi fi-rs-undo"></i>
                        <span *ngIf="isListView" class="ml-2">{{
                          "Revert" | translate
                        }}</span>
                      </button>
                      <a
                        class="inline-flex rounded-md ml-2 text-xs bg-white justify-center items-center h-8 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-gray-300 hover:!border-indigo-200 !border text-indigo-600 hover:!bg-indigo-50/[0.5] group hover:no-underline"
                        [class]="isListView ? 'px-2' : 'w-8'"
                        #tooltip="matTooltip"
                        matTooltip="{{
                          'Update product information' | translate
                        }}"
                        matTooltipPosition="above"
                        matTooltipHideDelay="100"
                        [routerLink]="item.is_product_mapped ? null : getEditProductLink(item.p_id, item.country_code)"
                        (click)="item.is_product_mapped && $event.preventDefault()"
                      >
                        <!-- <i class="fi fi-rs-menu-dots-vertical"></i> -->
                        <i class="fi fi-rs-pencil"></i>
                        <span *ngIf="isListView" class="ml-2">{{
                          "Edit" | translate
                        }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-5 col-12 text-center"
            *ngIf="!getDisplayedProducts()?.length"
          >
            <span>{{ "No product found." | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header p-4 border-bottom">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "Product Update" | translate }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="loadingInfo" class="text-center">
      <div class="loading-spinner col-12">
        <mat-spinner class="mx-auto my-3" [diameter]="50"></mat-spinner>
      </div>
    </div>
    <div class="row" *ngIf="!loadingInfo && customInfo">
      <div class="col pt-4 pt-lg-0 px-4">
        <form
          [formGroup]="productCustomerForm"
          (ngSubmit)="updateProductCustom()"
          method="post"
        >
          <div class="w-100 mt-3">
            <label class="form-label">{{ "Product Name" | translate }}</label>
            <input
              class="form-control"
              formControlName="product_name"
              value="{{ customInfo.product_name }}"
              type="text"
            />
          </div>
          <div class="mt-3">
            <label class="form-label">{{ "Product Photo" | translate }}</label>
            <div class="col">
              <media-selector
                [(imgURL)]="imgURL"
                [(mediaID)]="media_photo"
              ></media-selector>
            </div>
          </div>
          <div class="mt-3">
            <label class="form-label">{{ "Overview" | translate }}</label>
          </div>
          <div>
            <textarea
              class="content-editor-textarea product_overview"
              formControlName="product_overview"
            ></textarea>
          </div>
          <div class="mt-3">
            <label class="form-label">{{ "Description" | translate }}</label>
          </div>
          <div>
            <textarea
              class="content-editor-textarea product_desc"
              formControlName="product_desc"
            ></textarea>
          </div>
          <div class="mt-3">
            <button type="submit" class="btn btn-action --single">
              {{ "Save" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #uploade let-modal>
  <div class="uplode-popup">
    <div class="uploade-header p-3 border-bottom">
      <h2 class="mb-0">{{ "Upload Image" | translate }}</h2>
      <button
        type="button"
        class="close text-primary"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="uploade-body px-0 m-1 pb-0">
      <div class="section main">
        <div class="container col mb-4 mx-0">
          <mat-tab-group
            animationDuration="0ms"
            [disableRipple]="true"
            dynamicHeight
          >
            <mat-tab label="Upload Image">
              <div
                class="custom-dropzone"
                ngx-dropzone
                [accept]="'image/*'"
                (change)="onSelect($event)"
              >
                <ngx-dropzone-label>
                  <div>
                    <h2>{{ "Select your file or Drop it" | translate }}</h2>
                  </div>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview
                  ngProjectAs="ngx-dropzone-preview"
                  *ngFor="let f of files"
                  [file]="f"
                  [removable]="true"
                  (removed)="onRemove(f)"
                >
                </ngx-dropzone-image-preview>
              </div>
            </mat-tab>
            <mat-tab label="Choose from gallery">
              <div class="">
                <div class="mb-3">
                  <img
                    *ngIf="primary_photo"
                    [src]="primary_photo"
                    class="image-uploaded col-md-12"
                    style="width: 300px"
                  />
                </div>
                <div class="row mt-3">
                  <div class="col-3" *ngFor="let media of medias">
                    <div
                      (click)="imageSelect(media.photo, media.media_id)"
                      class="card mb-2"
                    >
                      <img height="200px" width="auto" [src]="media.photo" />
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>

    <div class="uploade-footer">
      <div align="right" class="mt-2 mr-4 mb-3">
        <div
          mat-button
          class="btn btn-action --single cancel"
          (click)="modal.dismiss('Cross click')"
        >
          {{ "Cancel" | translate }}
        </div>
        <div
          mat-button
          class="btn btn-action --single ml-2"
          (click)="modal.dismiss('Cross click')"
        >
          {{ "Save" | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #success let-modal>
  <div class="modal-body text-center">
    <div class="row" align="center">
      <div class="col pt-4 pt-lg-0">
        <h4>{{ "Successfully Update" | translate }}</h4>
      </div>
    </div>
    <button
      class="btn btn-primary"
      type="button"
      name="button"
      (click)="modal.close('Send click')"
    >
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #resetContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-reset-title">Reset Setting</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="text-secondary">
      {{ "Are you sure you want to reset this setting?" | translate }}
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="modal.close('Save click')"
    >
      {{ "Cancel" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="modal.close('delete')"
    >
      {{ "Reset" | translate }}
    </button>
  </div>
</ng-template>
